// extracted by mini-css-extract-plugin
export default {"button":"button_button__aUyKP","button_inversed":"button_button_inversed__-l--q","button_regular":"button_button_regular__BbA7g"};